import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import {config} from "../../../constant";
import {AppPieChart} from "../app";

export default function DialogArchiveCategoryStats({open, onClose, archiveCategoryId}) {
    const [archiveCategoryStats, setArchiveCategoryStats] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${config.BASE_URL}/archive-categories/stats/${archiveCategoryId}`)
            .then(response => {
                console.log(response.status);
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
                return response.json();
            })
            .then(data => {
                setArchiveCategoryStats(data);
            })
            .catch((error) => {
                const message = 'Erreur dans la récupération des stats de la catégorie archive';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    }, []);

    return (
        archiveCategoryStats && (
            <Dialog open={open} onClose={onClose} maxWidth={'sm'} fullWidth>
                <DialogTitle>Stats de la catégorie {archiveCategoryStats.name}</DialogTitle>
                <DialogContent>
                    <b>Années d'apparition : </b>{archiveCategoryStats.appearingYears.join(', ')}
                    {archiveCategoryStats.archivePeopleWithVictoriousYears.map(archivePersonStat => (
                        <Box key={archivePersonStat.id} sx={{mt: 1}}>
                            {archivePersonStat.firstName} : {archivePersonStat.victoriousYears.length} victoire{archivePersonStat.victoriousYears.length > 1 && 's'} ({archivePersonStat.victoriousYears.join(', ')})
                        </Box>
                    ))}
                    <AppPieChart sx={{mt: 3}}
                        chartData={archiveCategoryStats.archivePeopleWithVictoriousYears.map(archivePersonStat => {
                            return {
                                label: archivePersonStat.firstName,
                                value: archivePersonStat.victoriousYears.length
                            }
                        })}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>OK</Button>
                </DialogActions>
            </Dialog>
        )
    );
}
